export default __webpack_public_path__ + "static/media/P301 zu P303.5e9bf6de.mp3";